// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3o33f","inner":"Footer_inner__3H86K","nextIcon":"Footer_nextIcon__r-oyv","innerLeft":"Footer_innerLeft__3ZS5C"};